import React, { useState } from 'react';
import {
  Box,
  Pagination,
  Skeleton,
  Typography,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { DEFAULT_PAGE_INDEX } from '@tenant/utility/constants/default';
import useGetFailedCallbacks from 'redux/slices/webhookRegistration/hooks/useGetFailedCallbacks';

const PAGE_SIZE = 20;

const columns = [
  {
    field: 'CreatedAt',
    headerName: 'Date/Time',
    width: 180,
    sortable: false,
    renderCell: (params) =>
      params.value
        ? new Date(params.value).toLocaleString()
        : '-',
  },
  {
    field: 'Target',
    headerName: 'Endpoint',
    flex: 1,
    sortable: false,
  },
  {
    field: 'StatusName',
    headerName: 'Status',
    width: 120,
    sortable: false,
    renderCell: (params) => params.value || '-',
  },
  {
    field: 'ErrorMessage',
    headerName: 'Error Message',
    flex: 1,
    sortable: false,
  },
];

const FailedCallbacksTable = ({ hookId }) => {
  const [pageIndex, setPageIndex] = useState(DEFAULT_PAGE_INDEX);

  const { data, isLoading, isRefetching } = useGetFailedCallbacks({
    id: hookId,
    pageIndex,
    pageSize: PAGE_SIZE,
  });

  const result = data?.data;
  const rows = result?.Items ?? [];
  const totalCount = result?.TotalCount ?? 0;
  const loading = isLoading || isRefetching;

  return (
    <Box mt={2}>
      <Typography variant='subtitle1' fontWeight='bold' mb={1}>
        Failed Callbacks
      </Typography>

      {loading && rows.length === 0 ? (
        <Box>
          <Skeleton variant='rectangular' height={40} sx={{ mb: 1 }} />
          <Skeleton variant='rectangular' height={40} sx={{ mb: 1 }} />
          <Skeleton variant='rectangular' height={40} />
        </Box>
      ) : !loading && rows.length === 0 ? (
        <Typography color='text.secondary' variant='body2'>
          No failed callbacks recorded.
        </Typography>
      ) : (
        <>
          <DataGrid
            hideFooter
            autoHeight
            disableColumnSelector
            disableColumnMenu
            rows={rows}
            columns={columns}
            getRowId={(row) => row.Id}
            loading={loading}
          />
          <Box display='flex' justifyContent='center' mt={1}>
            <Pagination
              count={Math.ceil(totalCount / PAGE_SIZE) || 1}
              page={pageIndex}
              onChange={(_, v) => setPageIndex(v)}
              showFirstButton
              showLastButton
            />
            <Typography ml={2} alignSelf='center'>
              Total: {totalCount}
            </Typography>
          </Box>
        </>
      )}
    </Box>
  );
};

export default React.memo(FailedCallbacksTable);
